<template>
  <div>
    <div class="card-stage-container">
      <div
        id="stage-setting-container"
        class="stage-setting-container">
        <draggable
          :list="stages"
          :options="{draggable : '.draggable'}"
          @change="onChange($event)"
        >
          <div
            v-for="(stage, indexStage) in stages"
            :key="indexStage"
            class="stage draggable">
            <div class="stage-content">
              <div class="row">
                <div class="col-10 ellipsis text-left">{{ stage.name }}</div>
                <div
                  class="col-2 setting text-right"
                  @click="setStageFormMode('update', stage)">
                  <i class="fa fa-cog"/>
                </div>
              </div>

            </div>
          </div>

          <div
            id="stage-add"
            class="stage stage-add">
            <div class="stage-content">
              <span
                id="stageAdd"
                class="setting"
                @click="setStageFormMode('create')">
                Add Stage
              </span>
            </div>
          </div>
        </draggable>

        <b-popover
          ref="popoverStage"
          target="stageAdd"
          placement="auto"
          container="stage-add"
        >
          <h3>
            STAGE
          </h3>
          <b-form-group
            :class="{'error-input' : $v.dataStagePopover.name.$error}">
            <label>Stage Name</label>
            <j-input
              v-model="$v.dataStagePopover.name.$model"
              placeholder="Stage Name"/>
          </b-form-group>

          <b-form-group
            :class="{'error-input' : $v.dataStagePopover.cardLimit.$error}">
            <label>Maximum Card</label>
            <j-input
              v-model="$v.dataStagePopover.cardLimit.$model"
              type="number"
              placeholder="Maximum Card"/>
          </b-form-group>

          <!-- <b-form-group
            :class="{'error-input' : $v.dataStagePopover.taskState.$error}">
            <label>Task State</label>
            <j-single-select
              id="stagePrivilege"
              v-model="$v.dataStagePopover.taskState.$model"
              :options="listTaskStateOptions"
              :placeholder="'Select Task State'"
              value-format="object"/>
          </b-form-group> -->

          <b-form-group
            v-if="stageFormMode === 'update'">
            <label>DISABLE BACKWARD</label>
            <j-toggle
              v-model="$v.dataStagePopover.isDisableBackward.$model"/>
          </b-form-group>

          <b-form-group
            v-if="stageFormMode === 'update'">
            <label>ENABLE PRIVILEGE USER ACTION</label>
            <j-toggle
              v-model="$v.dataStagePopover.isPrivilageUserAction.$model"/>
          </b-form-group>

          <div
            v-if="$v.dataStagePopover.isPrivilageUserAction.$model && stageFormMode === 'update'"
            id="stage-config">
            <div
              class="btn-add-stage-privilege">
              <span
                id="stagePrivilegeAdd"
                class="font-weight-bold">
                <i class="fa fa-plus"/>
                Add
              </span>
            </div>

            <b-popover
              ref="popoverAddStagePrivilege"
              :show.sync="popoverLabelUpdateShow"
              target="stagePrivilegeAdd"
              triggers="click"
              placement="auto"
              container="stage-config"
            >
              <h3>
                Add Privilege
              </h3>
              <b-form-group
                :class="{'error-input' : $v.newStagePrivilege.$error}">
                <label for="stagePrivilege">New Privilege User</label>
                <j-single-select
                  id="stagePrivilege"
                  v-model="newStagePrivilege"
                  :options="listMemberOptions"
                  :placeholder="'Select'"
                  value-format="object"
                />
              </b-form-group>

              <b-button
                class="btn"
                @click="popoverLabelUpdateShow = false">
                Close
              </b-button>
              <b-button
                class="btn blue"
                @click="addStagePrivilege">
                Add
              </b-button>
            </b-popover>

            <b-row
              v-if="dataStagePopover.listMemberPrivilageUser.length > 0"
              class="assignee-list-vertical m__t--10">
              <div
                v-for="(member, indexMember) in dataStagePopover.listMemberPrivilageUser"
                :key="indexMember"
                class="col-12 m__b--5 assignee-detail">
                <div class="checkbox assignee-outer">
                  <label
                    :for="member.id"
                    class="row m__b--0 assignee-inner">
                    <div class="col-3 pr-0">
                      <img
                        v-if="getUserPhoto(member) !== '' && member.photo_url !== 'photo_url'"
                        :title="getUserEmail(member)"
                        :src="getUserPhoto(member)"
                        class="img-responsive card-assignee-photo-modal">
                      <span
                        v-else
                        :title="getUserEmail(member)"
                        class="card-assignee-initial-modal">
                        {{ getUserInitial(member) }}
                      </span>
                    </div>
                    <div class="col-7 pl-0">
                      <div class="f--bold">{{ getUserName(member) }}</div>
                      <div>{{ getUserTitle(member) }}</div>
                    </div>
                    <div class="col-2">
                      <span
                        class="assignee-remove"
                        @click="deleteStagePrivilege(member)">
                        <i class="fa fa-trash fa-2x"/>
                      </span>
                    </div>
                  </label>
                </div>
              </div>
            </b-row>

          </div>
          <br>

          <b-button
            class="btn"
            @click="closePopoverStage()">
            Cancel
          </b-button>
          <b-button
            v-if="stageFormMode === 'update'"
            class="btn red"
            @click="actionDeleteStage">
            Delete
          </b-button>
          <b-button
            class="btn blue"
            @click="actionStage">
            {{ stagePopoverAction }}
          </b-button>
        </b-popover>
      </div>
    </div>

  </div>
</template>

<script>
/* eslint-disable max-len */
import draggable from 'vuedraggable';
import jMixBoard from '@/mixins/jMixBoard';
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';

export default {
  // eslint-disable-next-line
  name: 'jBoardStageTab',
  components: {
    draggable,
  },
  mixins: [
    jMixBoard,
  ],
  props: {
    board: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      stageFormMode: 'create',
      popoverStageShow: false,
      stages: [],
      dataStagePopover: {
        name: null,
        cardLimit: null,
        taskState: null,
        isDisableBackward: false,
        isPrivilageUserAction: false,
        memberPrivilageUserAction: [],
        listMemberPrivilageUser: [],
      },
      popoverLabelUpdateShow: false,
      newStagePrivilege: null,
      listMemberOptions: [],
      listTaskStateOptions: [
        {
          id: 'selected',
          text: 'Selected',
        },
        {
          id: 'in progress',
          text: 'In Progress',
        },
        {
          id: 'pending',
          text: 'Pending',
        },
        {
          id: 'done',
          text: 'Done',
        },
      ],
    };
  },
  computed: {
    ...mapState('jStoreBoard', ['state_board']),
    stagePopoverAction() {
      return this.stageFormMode === 'create' ? 'Submit' : 'Update';
    },
    generateData() {
      if (this.dataStagePopover !== null) {
        if (this.stageFormMode === 'create') {
          return {
            board_id: Number(this.board.id),
            name: this.dataStagePopover.name,
            card_limit: Number(this.dataStagePopover.cardLimit),
            // task_state: this.dataStagePopover.taskState ? this.dataStagePopover.taskState.id : '',
          };
        }
        return {
          board_id: Number(this.board.id),
          stage_id: this.dataStagePopover.stage.id,
          name: this.dataStagePopover.name,
          card_limit: Number(this.dataStagePopover.cardLimit),
          // task_state: this.dataStagePopover.taskState ? this.dataStagePopover.taskState.id : '',
          order: this.dataStagePopover.stage.order,
          is_disable_backward: this.dataStagePopover.isDisableBackward,
          is_privilage_user_action: this.dataStagePopover.isPrivilageUserAction,
          // eslint-disable-next-line
          member_privilage_user_action: this.dataStagePopover.isPrivilageUserAction ? this.dataStagePopover.memberPrivilageUserAction : [],
        };
      }
      return null;
    },
  },
  watch: {
    // eslint-disable-next-line
    'state_board.stages': function(data) {
      const stagesTemp = JSON.parse(JSON.stringify(data.stages));
      this.stages = stagesTemp.sort((a, b) => a.order - b.order);
    },
    // eslint-disable-next-line
    'state_board.assignees': function(data) {
      this.listMemberOptions = [];
      data.forEach((lab) => {
        this.listMemberOptions.push({
          ...lab,
          text: `${lab.first_name} - ${lab.email}`,
          label: `${lab.first_name} - ${lab.email}`,
          is_delete: false,
        });
      });
    },
  },
  created() {
    this.actionGetBoardStages(this.board.id);
  },
  methods: {
    ...mapActions('jStoreBoard', ['actionGetBoardStages', 'actionCreateBoardStages',
      'actionUpdateBoardStages', 'actionDeleteBoardStages']),

    onChange(e) {
      const req = {
        board_id: Number(this.board.id),
        stage_id: e.moved.element.id,
        name: e.moved.element.name,
        card_limit: e.moved.element.card_limit ? e.moved.element.card_limit : null,
        order: e.moved.newIndex + 1,
      };
      this.actionUpdateBoardStages(req);
    },

    setStageFormMode(mode, stage) {
      this.stageFormMode = mode;
      if (mode === 'create') {
        this.dataStagePopover.name = null;
        this.dataStagePopover.cardLimit = null;
        // this.dataStagePopover.taskState = null;
        this.dataStagePopover.isDisableBackward = false;
        this.dataStagePopover.isPrivilageUserAction = false;
        this.dataStagePopover.memberPrivilageUserAction = [];
        this.dataStagePopover.listMemberPrivilageUser = [];
        this.dataStagePopover.stage = null;
      } else {
        this.dataStagePopover.name = stage.name;
        this.dataStagePopover.cardLimit = stage.card_limit ? stage.card_limit : null;
        // this.dataStagePopover.taskState = stage.task_state ? stage.task_state : null;
        this.dataStagePopover.isDisableBackward = stage.is_disable_backward === 1;
        this.dataStagePopover.isPrivilageUserAction = stage.is_privilage_user === 1;
        this.dataStagePopover.stage = stage;

        if (stage.member_privilage_user) {
          JSON.parse(stage.member_privilage_user).forEach((val) => {
            this.dataStagePopover.memberPrivilageUserAction.push({ company_user_id: val });
          });

          this.dataStagePopover.listMemberPrivilageUser = this.state_board.assignees
            .filter(el => stage.member_privilage_user.includes(el.user_company_id));
        }
      }
      this.$v.dataStagePopover.$reset();
      this.$refs.popoverStage.$emit('open');
      // this.$refs.popoverStage.show();
    },
    closePopoverStage() {
      this.dataStagePopover.name = null;
      this.dataStagePopover.cardLimit = null;
      this.dataStagePopover.isDisableBackward = false;
      this.dataStagePopover.isPrivilageUserAction = false;
      this.dataStagePopover.memberPrivilageUserAction = [];
      this.dataStagePopover.listMemberPrivilageUser = [];
      this.dataStagePopover.stage = null;
      this.$refs.popoverStage.$emit('close');
    },
    actionStage() {
      this.$v.dataStagePopover.$touch();
      if (!this.$v.dataStagePopover.$error) {
        if (this.stageFormMode === 'create') {
          this.actionCreateBoardStages(this.generateData);
        } else {
          this.actionUpdateBoardStages(this.generateData);
        }

        this.closePopoverStage();
      }
    },
    actionDeleteStage() {
      const param = {
        board_id: Number(this.board.id),
        stageId: this.dataStagePopover.stage.id,
      };
      this.actionDeleteBoardStages(param);
      this.closePopoverStage();
    },
    addStagePrivilege() {
      this.$v.newStagePrivilege.$touch();
      if (!this.$v.newStagePrivilege.$error) {
        const req = {
          company_user_id: this.newStagePrivilege.user_company_id,
        };
        this.dataStagePopover.memberPrivilageUserAction.push(req);
        this.dataStagePopover.listMemberPrivilageUser.push(this.newStagePrivilege);

        this.newStagePrivilege = null;
        this.$v.newStagePrivilege.$reset();
        this.popoverLabelUpdateShow = false;
      }
    },
    deleteStagePrivilege(member) {
      if (member) {
        this.$swal({
          title: '<div style="color:#D2232A">Delete</div>',
          type: 'warning',
          html: `Are you sure to delete <span style="font-family: Poppins-Medium; font-size: 18px;">${member.first_name} ${member.last_name}</span>?`,
          showCancelButton: true,
          confirmButtonText: 'Delete',
          confirmButtonColor: '#D2232A',
          cancelButtonColor: '#D2232A',
          titleColor: '#D2232A',
        }).then((result) => {
          if (result.value) {
            // eslint-disable-next-line
            this.dataStagePopover.memberPrivilageUserAction = this.dataStagePopover.memberPrivilageUserAction.filter(val => val.company_user_id !== member.user_company_id);
            // eslint-disable-next-line
            this.dataStagePopover.listMemberPrivilageUser = this.dataStagePopover.listMemberPrivilageUser.filter(val => val.user_company_id !== member.user_company_id);
          }
        });
      }
    },
  },
  validations() {
    return {
      dataStagePopover: {
        name: { required },
        cardLimit: {},
        taskState: {},
        isDisableBackward: {},
        isPrivilageUserAction: {},
        memberPrivilageUserAction: {},
      },
      newStagePrivilege: { required },
    };
  },
};

</script>


<style lang="scss" scoped>
  .card-stage-container {
    // background-color: #e7e9ed;
    // padding: 20px 20px 15px 20px ;
    // margin: 0 -20px 60px -20px;
    .stage-setting-container {
      // overflow: auto;
      // white-space: nowrap;
      .stage {
        display: inline-block;
        width: 100%;
        border-radius: 7px;
        box-shadow: 0 0 4px 0 rgba(154, 152, 152, 0.5);
        background-color: #f2f3f5;
        margin-bottom: 15px;
        padding: 10px;
        cursor: move;

        .stage-content {
          width: 100%;
          position: relative;
          font-family: Poppins-Medium;
          font-size: 14px;

          .setting {
            width: 100%;
            display: table-cell;
            text-align: center;
            vertical-align: middle;
            cursor: pointer;
          }
        }
        &.stage-add {
          border: 2px dashed #c4c5c8;
          box-shadow: none;
        }
      }

      .btn-add-stage-privilege {
        width: fit-content;
        padding: 0 5px;
        cursor: pointer;
        border-radius: 4px;
        background-color: #f2f2f2;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/views/board/tabs/jBoardStageTab.vue